import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { Centre, AddCentreDto, UpdateCentreTableDto, CentreListDTO } from "../_models/Centre";
import { AppConstants } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class CentreService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "Centre/";
  private static readonly ISVALIDCENTRENAME_URI = "isvalidcentrename/";
  private static readonly UPDATECENTRELIST_URI = "updatecentrelist/"
  private static readonly RESETCENTRELIST_URI = "resetcentrelist/";
  private static readonly DISPLAYCENTRELIST_URI = "displaycentrelist";
  private static readonly GETCENTRELISTLENGTH_URI = "centrelistlength/";
  private static readonly GETCENTRESBYUSERIDORGID_URI = "getallbyuseridandorgid/";
  private static readonly VALIDATEDELETECENTRE_URI = "validatedelete/";
  private static readonly GETALL_CENTRE_BY_ORGIDS: string = "getallbyorgids";
  private static readonly TUTORGETALLBYORGIDS_URI: string = "tutorflow/getallbyorgids";

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  public addCentre$(addCentreDto: AddCentreDto): Observable<Centre>{
    return this.http.post<Centre>(this.baseUrl + CentreService.path, addCentreDto);
  }

  public getCentres$(): Observable<Centre[]> {
    return this.http.get<Centre[]>(this.baseUrl + CentreService.path);
  }

  public updateCentreTableRecords$(updateDto: UpdateCentreTableDto): Observable<boolean> {
    return this.http.put<boolean>(this.baseUrl + CentreService.path + CentreService.UPDATECENTRELIST_URI, updateDto);
  }

  public getCentreTableRecord$(pageIndex: number, isInitialLoad: boolean): Observable<CentreListDTO[]> {
    let params = new HttpParams().set("pageNumber", String(+pageIndex + 1));
    if(isInitialLoad)
    params = params.set("isInitialLoad", String(isInitialLoad));

    return this.http.get<CentreListDTO[]>(this.baseUrl + CentreService.path + CentreService.DISPLAYCENTRELIST_URI, { params });
  }

  public resetCentreTable$(): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + CentreService.path + CentreService.RESETCENTRELIST_URI);
  }

  public getCentreTableLength$(): Observable<number> {
    return this.http.get<number>(this.baseUrl + CentreService.path + CentreService.GETCENTRELISTLENGTH_URI);
  }

  public getCentresByOrgId$(orgId: number): Observable<Centre[]> {
    return this.http.get<Centre[]>(this.baseUrl + CentreService.path + "getallbyorgid/"+orgId);
  }

  public updateCentre$(centre: Centre): Observable<Centre> {
    return this.http.put<Centre>(`${this.baseUrl}${CentreService.path}${centre.id}`, centre);
  }

  public isValidCentreName$(centreAddDTO: AddCentreDto): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.baseUrl}${CentreService.path}${CentreService.ISVALIDCENTRENAME_URI}`, centreAddDTO);
  }

  public getCentresByUserIdAndOrgId$(userId: number, orgId: number): Observable<Centre[]> {
    return this.http.get<Centre[]>(`${this.baseUrl}${CentreService.path}${CentreService.GETCENTRESBYUSERIDORGID_URI}${userId}/${orgId}`);
  }

  public getCentresByOrgIdsTutorFlow$(orgIds: number[]): Observable<Centre[]> {
    return this.http.post<Centre[]>(`${this.baseUrl}${CentreService.path}${CentreService.TUTORGETALLBYORGIDS_URI}`, orgIds);
  }

  public deleteCentre$(id: number): Observable<Object> {
    return this.http.delete(`${this.baseUrl}${CentreService.path}${id}`);
  }

  public validateDeleteCentre$(id: number): Observable<Object> {
    return this.http.get(`${this.baseUrl}${CentreService.path}${CentreService.VALIDATEDELETECENTRE_URI}${id}`);
  }

  public getAllCentresByOrgIds$(orgIds: number[]): Observable<Centre[]> {
    let params = new HttpParams();
    orgIds.forEach((id) => {
      params = params.append(AppConstants.ORG_IDS, String(+id));
    });

    return this.http.get<Centre[]>(
      this.baseUrl + 
      CentreService.path + 
      CentreService.GETALL_CENTRE_BY_ORGIDS, 
      {params}
    );
  }
}
